import { AppConfigResponse } from './app-config.wire';
import { AppConfigValuesState } from './app-config.state';

/**
 * Backend GET response -> slice state. The single place PascalCase wire fields become the
 * slice's camelCase state; mirrors `AppConfigService.fetchConfig`'s `tap((apiResponse) =>
 * this.configSubject.next(apiResponse))`, just moved from a `BehaviorSubject` into the store.
 */
export function appConfigResponseToState(response: AppConfigResponse): AppConfigValuesState {
    const locationTracker = response.LocationTracker;
    return {
        locationTracker: locationTracker
            ? {
                  enabled: locationTracker.Enabled,
                  privacyZoneRadiusMeters: locationTracker.PrivacyZoneRadiusMeters,
                  precisionMeters: locationTracker.PrecisionMeters,
              }
            : undefined,
    };
}
